<div class="avd-provisioning-status">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <nz-spin nzSimple></nz-spin>
    <p>Loading provisioning status...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <nz-alert
      nzType="error"
      [nzMessage]="error"
      nzShowIcon
      nzCloseable
      (nzOnClose)="error = null"
    ></nz-alert>
  </div>

  <!-- Provisioning Status -->
  <div *ngIf="provisioningStatus && !isLoading" class="status-container">
    <nz-card [nzTitle]="'AVD Provisioning Status'" [nzExtra]="refreshTemplate">
      <!-- Status Badge -->
      <div class="status-badge">
        <nz-tag [nzColor]="getStatusColor()">
          <i nz-icon [nzType]="getStatusIcon()" nzTheme="outline"></i>
          {{ provisioningStatus.status }}
        </nz-tag>
        <span class="status-message">{{ getStatusMessage() }}</span>
      </div>

      <!-- Status Details -->
      <nz-descriptions [nzColumn]="2" nzBordered nzSize="small">
        <nz-descriptions-item nzTitle="Ticket ID">
          {{ provisioningStatus.ticketId }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Attempt Number">
          #{{ provisioningStatus.attemptNumber }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="VM Size">
          {{ provisioningStatus.vmSize || 'N/A' }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Host Name">
          {{ provisioningStatus.hostName || 'N/A' }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Started">
          {{ formatDate(provisioningStatus.startedUtc) }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Completed">
          {{ formatDate(provisioningStatus.completedUtc) }}
        </nz-descriptions-item>
      </nz-descriptions>

      <!-- Failure Details -->
      <div *ngIf="provisioningStatus.status === 'Failed'" class="failure-details">
        <nz-alert
          nzType="error"
          nzShowIcon
          [nzMessage]="'Provisioning Failed'"
          [nzDescription]="failureTemplate"
        ></nz-alert>
        <ng-template #failureTemplate>
          <p><strong>Error Code:</strong> {{ provisioningStatus.failureCode }}</p>
          <p><strong>Message:</strong> {{ provisioningStatus.failureMessage }}</p>
          <button
            nz-button
            nzType="primary"
            [nzLoading]="isRetrying"
            (click)="retryProvisioning()"
            class="retry-btn"
          >
            <i nz-icon nzType="reload" nzTheme="outline"></i>
            Retry Provisioning
          </button>
        </ng-template>
      </div>

      <!-- Connection Details -->
      <div *ngIf="provisioningStatus.status === 'Success' && provisioningStatus.hasConnectionDetails" class="connection-details">
        <nz-divider [nzText]="'Connection Details'"></nz-divider>
        
        <div *ngIf="isLoadingConnection" class="loading-connection">
          <nz-spin nzSimple></nz-spin>
          <span>Loading connection details...</span>
        </div>

        <div *ngIf="connectionDetails && !isLoadingConnection">
          <!-- Expiry Warning -->
          <nz-alert
            *ngIf="areCredentialsExpiringSoon() && !areCredentialsExpired()"
            nzType="warning"
            nzShowIcon
            [nzMessage]="'Credentials Expiring Soon'"
            [nzDescription]="'Your temporary credentials will expire in ' + connectionDetails.daysUntilExpiry + ' days.'"
            nzCloseable
          ></nz-alert>

          <nz-alert
            *ngIf="areCredentialsExpired()"
            nzType="error"
            nzShowIcon
            [nzMessage]="'Credentials Expired'"
            [nzDescription]="'Your temporary credentials have expired. Please request a new provisioning.'"
          ></nz-alert>

          <!-- Connection Link -->
          <div class="connection-item">
            <label>Connection Link:</label>
            <nz-input-group [nzSuffix]="copyLinkTemplate">
              <input
                nz-input
                [value]="connectionDetails.connectionLink || 'N/A'"
                readonly
              />
            </nz-input-group>
            <ng-template #copyLinkTemplate>
              <button
                nz-button
                nzType="link"
                nzSize="small"
                (click)="copyConnectionLink()"
              >
                <i nz-icon nzType="copy" nzTheme="outline"></i>
              </button>
            </ng-template>
          </div>

          <!-- Credentials (if authorized) -->
          <div *ngIf="connectionDetails.temporaryUsername && connectionDetails.temporaryPassword" class="credentials-section">
            <nz-alert
              nzType="info"
              nzShowIcon
              [nzMessage]="'Temporary Credentials'"
              [nzDescription]="credentialsTemplate"
            ></nz-alert>
            <ng-template #credentialsTemplate>
              <div class="credential-item">
                <strong>Username:</strong>
                <code>{{ connectionDetails.temporaryUsername }}</code>
              </div>
              <div class="credential-item">
                <strong>Password:</strong>
                <code>{{ connectionDetails.temporaryPassword }}</code>
              </div>
              <div class="credential-item">
                <strong>Expires:</strong>
                <span>{{ formatDate(connectionDetails.credentialExpiresUtc) }}</span>
                <span class="expiry-badge">({{ connectionDetails.daysUntilExpiry }} days remaining)</span>
              </div>
              <button
                nz-button
                nzType="default"
                nzSize="small"
                (click)="copyCredentials()"
                class="copy-credentials-btn"
              >
                <i nz-icon nzType="copy" nzTheme="outline"></i>
                Copy Credentials
              </button>
            </ng-template>
          </div>

          <!-- Connection File Download -->
          <div *ngIf="connectionDetails.connectionFileUri" class="connection-file">
            <a [href]="connectionDetails.connectionFileUri" target="_blank" download>
              <button nz-button nzType="primary">
                <i nz-icon nzType="download" nzTheme="outline"></i>
                Download RDP File
              </button>
            </a>
          </div>
        </div>
      </div>
    </nz-card>
  </div>

  <!-- Refresh Template -->
  <ng-template #refreshTemplate>
    <button
      nz-button
      nzType="link"
      nzSize="small"
      (click)="refreshStatus()"
      [disabled]="isLoading"
    >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      Refresh
    </button>
  </ng-template>
</div>























